AoPS.AskAoPS = AoPS.AskAops = {
	/**
	 * Display AskAops form
	 */
	display: function (checked) {
		// contruct HTML - inline to prevent requirement of having to have
		// Handlebars loaded
		var html = [
			'<div class="aops-modal-body clearfix askaops">',
			'<div class="askaops-categories">',
			"<h1>Ask AoPS</h1>",
			"<strong>I have a question about:</strong><br>",
			'<div style="padding-left:10px;padding-top:10px;line-height:2em;">',
			'<label><input type="radio" name="askaops-category" value="general" checked="checked"> General Information</label>',
			'<label><input type="radio" name="askaops-category" value="book"> Book Recommendations</label>',
			'<label><input type="radio" name="askaops-category" value="class"> Class Recommendations</label>',
			'<label><input type="radio" name="askaops-category" value="order"> Order Information</label>',
			'<label><input type="radio" name="askaops-category" value="myclass"> My Current Class</label>',
			'<label><input type="radio" name="askaops-category" value="technical"> Technical Support</label>',
			'<label><input type="radio" name="askaops-category" value="other"> Other</label>',
			"</div>",
			"</div>",
			'<div class="askaops-form">',
			'<div id="askaops-blurb">Have a general question about Art of Problem Solving? Let us know below.</div>',
			'<div data-hj-suppress="" data-hj-masked="" id="askaops-error" class="error-box"></div>',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-subject" class="form-control" placeholder="Message Subject">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-ordernumber" class="askaops-ordernumber form-control" placeholder="Order number - if known">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-course" class="askaops-course form-control" placeholder="Class name and id - if known">',
			'<textarea data-hj-suppress="" data-hj-masked="" id="askaops-message" class="form-control"  style="margin-top:10px;height:100px;" placeholder="How can we help you?"></textarea>',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-username" class="askaops-username form-control" placeholder="AoPS Username - if known">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-name" style="margin-top:10px" class="form-control" placeholder="Your name">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-email" style="margin-top:10px" class="form-control" placeholder="Your email address">',
			'<div style="text-align:right">',
			'<input id="askaops-submit" style="margin-top:10px" type="submit" class="btn-lg btn btn-primary" value="Submit your message">',
			"</div>",
			"</div>",
			"</div>",
		];
		html = html.join("\n");

		// Display the ask aops form
		AoPS.Ui.Modal.showPlain({
			body: html,
			width: "75%",
			onClose: this.onClose,
			scrollable: false,
			frame_class: "askaops-modal",
			// v PROJ-493
			height: "",
			max_height: "",
		});
		$(".askaops-modal")
			.parent(".aops-modal-wrapper")
			.addClass("askaops-modal-wrapper");

		if (typeof checked !== "undefined") {
			setTimeout(function () {
				if (checked === "class") {
					$(".askaops input[name='askaops-category'][value=class]").prop(
						"checked",
						true
					);
					AoPS.AskAoPS.onChange();
				} else if (checked === "book") {
					$(".askaops input[name='askaops-category'][value=book]").prop(
						"checked",
						true
					);
					AoPS.AskAoPS.onChange();
				}
			}, 1);
		}

		// Could not get onShow to work in modal so just putting it here.
		this.onShow();
	},

	/**
	 * Event called when the "I have a question about:" radio buttons
	 * are changed. Basically sets the blurb above the form.
	 */
	onChange: function (e) {
		var selected = $(".askaops input[name='askaops-category']:checked").val();

		var general_rec_blurb = [
			"Have a general question about Art of Problem Solving?",
			"Let us know below.",
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		].join(" ");

		var book_rec_blurb = [
			"Please tell us about your student's math background, including",
			"their grade level, recent math classes, and contest experience",
			"(if any), as well as your goals for choosing books. You can also",
			"find suggestions on our ",
			'<a href="/store/recommendations">Recommendations page</a>.',
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		].join(" ");

		var class_rec_blurb = [
			"Please tell us about your student's math background, including",
			"their grade level, recent math classes, and contest experience",
			"(if any), as well as your goals for choosing a course. You can",
			"also find suggestions on our",
			'<a href="/school/recommendations">Recommendations page</a>.',
			"Visit <a href=http://www.artofproblemsolving.com/school/how-school-works/faqs>",
			"Frequently Asked Questions</a> for quick answers to common class questions.",
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		].join(" ");

		var order_blurb = [
			"Have a question about an order? Let us know below.",
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		].join(" ");

		var myclass_blurb = [
			"Have a question about your current class? Let us know below.",
			'Visit <a href="/school/how-school-works/faqs">Frequently Asked Questions</a>',
			"for quick answers to common class questions.",
			"<p>Specific questions about homework problems or assignments",
			"should be posted to your course's message board.",
			"Extension requests can be made from your class homepage.</p>",
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		].join(" ");

		var other_blurb =
			"<a href='../company/privacy'>View our Privacy Policy</a>.";

		var tech_blurb = [
			"Please include a detailed description of the error or issue you ",
			"are experiencing.",
			"<a href='../company/privacy'>View our Privacy Policy</a>.",
		];

		$("#askaops-username").hide();
		$("#askaops-ordernumber").hide();
		$("#askaops-course").hide();

		switch (selected) {
			case "general":
				$("#askaops-blurb").html(general_rec_blurb);
				break;
			case "book":
				$("#askaops-blurb").html(book_rec_blurb);
				break;
			case "class":
				$("#askaops-blurb").html(class_rec_blurb);
				break;
			case "order":
				$("#askaops-blurb").html(order_blurb);
				$("#askaops-ordernumber").show();
				break;
			case "myclass":
				$("#askaops-blurb").html(myclass_blurb);
				$("#askaops-username").show();
				$("#askaops-course").show();
				break;
			case "technical":
				$("#askaops-username").show();
				$("#askaops-blurb").html(tech_blurb);
				break;
			case "other":
				$("#askaops-blurb").html(other_blurb);
				break;
		}
	},

	/**
	 * Submit form to server when submit button is pressed
	 */
	onSubmit: function () {
		$("#askaops-submit").off("click", AoPS.AskAoPS.onSubmit);

		var type = $(".askaops input[name='askaops-category']:checked").val();

		$.post(
			"/m/contact/ajax.php",
			{
				action: "email",
				type: type,
				username: $("#askaops-username").val(),
				email: $("#askaops-email").val(),
				name: $("#askaops-name").val(),
				subject: $("#askaops-subject").val(),
				message: $("#askaops-message").val(),
				orderid: $("#askaops-ordernumber").val(),
				course: $("#askaops-course").val(),
				url: window.location.href,
			},
			function (data) {
				if (data.error_msg) {
					$("#askaops-error").html(data.error_msg).show();
					$("#askaops-submit").on("click", AoPS.AskAoPS.onSubmit);
				} else {
					AoPS.Ui.Modal.closeTopModal();

					var thanks = [
						"<p>Thank you. We have received your comment or question.</p>",
						"<p>One of our staff members will respond to you within two",
						"business days.</p>",
					];
					AoPS.Ui.Modal.showAlertQuick(thanks.join(" "));
				}
			}
		);
	},

	/**
	 * Enable events when modal is displayed
	 */
	onShow: function () {
		$(".askaops input[name='askaops-category']").on("change", this.onChange);
		$("#askaops-submit").on("click", this.onSubmit);
	},

	/**
	 * Disable events when modal goes byebye
	 */
	onClose: function () {
		$(".askaops input[name='askaops-category']").off("change", this.onChange);
		$("#askaops-submit").off("click", this.onSubmit);
	},
};
